import React, { useEffect, useState } from "react";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import {
  CustomChartsTitle,
  CustomValue,
} from "../../components/Custom/CustomTypography";
import CustomDashboardCard from "../../components/Custom/CustomDashboard";
import { Grid, Box, Card, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomDetailedList from "../../components/Custom/CustomDetailedList";
import { useNavigate } from "react-router-dom";

const SponsorDashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [data, setData] = useState([]);

  // const data = [
  //   {
  //     farmerName: "Kisan Patil",
  //     credits: "300",
  //     program: "Stubble",
  //   },
  // ];

  useEffect(() => {
    loadTasks();
  }, []);

  const loadTasks = async () => {
    try {
      const result = await api.get(`/programs/all-programs/`);
      setData(result.data);
    } catch (err) {
      console.log(
        "Error: " +
          (err.response?.data?.non_field_errors?.[0] || "An error occurred")
      );
    }
  };

  const renderProgramData = (program) => {
    const programInput = program.program_inputs?.[0] || {};
    return [
      {
        label: t("Program Name "),
        value: program.name || t("N/A"),
      },
      {
        label: t("Crops "),
        value: programInput.commodity?.name || t("N/A"),
      },
      {
        label: t("Geographies "),
        value: programInput.states?.name || t("N/A"),
      },
      {
        label: t("Cost to farmer "),
        value: programInput.farmer_cost
          ? `${programInput.farmer_cost} Rs. per acre`
          : t("N/A"),
      },
      {
        label: t("GHG "),
        value: programInput.ghg ? `${programInput.ghg} per acre` : t("N/A"),
      },
      {
        label: t("Water "),
        value: programInput.water ? `${programInput.water} per acre` : t("N/A"),
      },
      {
        label: t("Program end date "),
        value: programInput.program_end_date || t("N/A"),
      },
    ];
  };

  const handleViewProgramDetails = (programId) => {
    navigate(`/programs/${programId}`);
  };

  return (
    <>
      <CustomAppBar />
      <Container maxWidth="xs">
        <div>
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <Box sx={{ marginTop: "20px" }}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <CustomDashboardCard title={t("My Programs")} data={"0"} />
                </Grid>
                <Grid item xs={4}>
                  <CustomDashboardCard title={t("All Programs")} data={"0"} />
                </Grid>
                <Grid item xs={4}>
                  <CustomDashboardCard title={t("Carbon Ledger")} data={"0"} />
                </Grid>
              </Grid>
            </Box>

            <Box sx={{ marginTop: "20px" }}>
              <CustomChartsTitle>{t("Sponsor Details")}</CustomChartsTitle>
              <Grid container spacing={1} sx={{ padding: "10px 0" }}>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("New Farmers 0")}</CustomValue>
                  </Card>
                </Grid>
                <Grid item xs={6}>
                  <Card
                    sx={{
                      boxShadow: "none",
                      padding: "10px",
                      textAlign: "center",
                    }}
                  >
                    <CustomValue>{t("Total Sponsored 0")}</CustomValue>
                  </Card>
                </Grid>
              </Grid>
            </Box>

            {/* <Box>
              <Grid item xs={12} height="150px">
                <CustomTransactionTable columns={columns} data={data} />
              </Grid>
            </Box> */}

            <Box>
              <CustomChartsTitle>{t("All Programs : ")}</CustomChartsTitle>

              <Box mt={2}>
                {data.map((program) => (
                  <Box
                    key={program.id}
                    onClick={() => handleViewProgramDetails(program.id)}
                  >
                    <CustomDetailedList
                      id={program.id}
                      data={renderProgramData(program)}
                      buttonList={[]}
                    />
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </div>
      </Container>
    </>
  );
};

export default SponsorDashboard;
